import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.section `
  position: fixed;
  top: var(--headerContainerHeight);
  left: 0;
  display: flex;
  flex-direction: row;
  background: ${brand.white};
  color: ${brand.grey.grey6};
  height: calc(100% - var(--headerContainerHeight));
  opacity: 0;
  overflow-y: auto;
  padding: 54px 18px;
  pointer-events: none;
  transition: opacity 0.15s ${cubicEaseOut};
  width: 100%;
  z-index: ${Layers.Header};

  &[data-s-active='true'] {
    opacity: 1;
    pointer-events: all;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 72px 72px 72px 18px;
    top: var(--headerHeight);
    height: calc(100% - var(--headerHeight));
  }
`;
const Inner = styled.div `
  margin: 0 auto;
  max-width: 568px;
  width: 100%;
`;
const FieldWrapper = styled.form `
  position: relative;
  display: block;
  border-bottom: 1px solid ${brand.grey.grey6};
  margin: 0 0 32px;
  padding: 0 0 8px;
`;
const Input = styled.input `
  display: block;
  appearance: none !important;
  background: none;
  border: 0;
  color: ${brand.black};
  ${fonts.body.bold};
  font-size: 20px;
  letter-spacing: -0.01em;
  line-height: 1em;
  margin: 0;
  padding: 0;
  text-indent: 6px;
  width: 95%;

  &::placeholder {
    color: ${brand.grey.grey3};
    opacity: 1;
    text-indent: 12px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 32px;
  }
`;
const Submit = styled.button `
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  background: none;
  border: 0;
  margin: 0;
  padding: 0;
  place-content: center;
  place-items: center;
  transform: translateY(-50%) translateY(-4px);

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }
`;
const SuggestionTitle = styled.span `
  display: block;
  color: currentColor;
  ${fonts.heading.bold};
  font-size: 16px;
  letter-spacing: -0.01em;
  line-height: 1em;
  margin: 0 0 24px;

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
  }
`;
const SuggestionList = styled.ul `
  display: block;
  margin: 0;
  padding: 0;
`;
const SuggestionItem = styled.li `
  display: block;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;
const SuggestionLink = styled.a `
  display: block;
  color: ${brand.grey.grey4};
  ${fonts.body.regular};
  font-size: 16px;
  letter-spacing: -0.01em;
  line-height: 1em;
  text-decoration: none;

  &:focus,
  &:hover {
    color: ${brand.blue.base};
    text-decoration: underline;
    text-underline-position: under;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 18px;
  }
`;
const CloseButton = styled.button `
  display: inline-flex;
  background: none;
  border: 0;
  color: ${brand.black};
  height: 20px;
  padding: 0;
  place-content: center;
  place-items: center;
  width: 20px;
  margin-left: 1rem;
  margin-top: 5px;

  svg {
    display: block;
    height: 20px;
    width: 20px;
  }

  &:focus {
    outline: auto;
    outline-offset: 5px;
  }

  @media ${from(Device.TabletLarge)} {
    margin-left: 0;
  }
`;
const SearchOverlayStyles = {
    Container,
    FieldWrapper,
    Inner,
    Input,
    Submit,
    SuggestionItem,
    SuggestionLink,
    SuggestionList,
    SuggestionTitle,
    CloseButton,
};
export default SearchOverlayStyles;
